import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { createEpicMiddleware } from 'redux-observable';
import persistState from 'redux-localstorage';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import logger from 'redux-logger';
import rootEpic from '../epics';
import {
  reducer,
  storage
} from './reducerAndStorage';
import { storageKeys } from '../shared/constants';

const configureStore = (initialState = {}, history) => {
  const prodMiddlewares = [
    createEpicMiddleware(rootEpic),
    routerMiddleware(history)
  ];

  const devMiddlewares = [
    logger,
    reduxImmutableStateInvariant({
      ignore: [
        'form.dashboardMassUpload.values.uploadFile'
      ],
    }),
    ...prodMiddlewares
  ];

  const middlewares = process.env.NODE_ENV === 'production' ? prodMiddlewares : devMiddlewares;

  const enhancers = [
    applyMiddleware(...middlewares),
    persistState(storage, storageKeys.techniciansForm)
  ];

  /* eslint-disable no-underscore-dangle */
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
  /* eslint-enable */

  const store = createStore(
    reducer,
    initialState,
    composeEnhancers(...enhancers),
  );

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js